document.addEventListener('DOMContentLoaded', () => {
  const whatsapp = document.querySelector('.whatsapp.desktop-only');
  if (!whatsapp) return;

  const btnOpen = whatsapp.querySelector('.whatsapp_button .open');
  const btnClose = whatsapp.querySelector('.whatsapp_button .close');
  const tooltipIntro = whatsapp.querySelector('.tooltip-intro');
  const tooltipCustomer = whatsapp.querySelector('.tooltip-customer');
  const tooltipIntroLink = whatsapp.querySelector('.tooltip-intro_link');

  const SESSION_KEY = 'whatsapp_tooltip_seen';
  let introHidden = false;

  const showElement = (el) => {
    if (!el) return;
    el.classList.remove('hide');
    el.classList.add('show');
  };
  const hideElement = (el) => {
    if (!el) return;
    el.classList.remove('show');
    el.classList.add('hide');
  };

  // --- Tooltip Customer ---
  const showTooltipCustomer = () => {
    showElement(tooltipCustomer);
    hideElement(tooltipIntro);
    hideElement(btnOpen);
    showElement(btnClose);
  };

  const hideTooltipCustomer = () => {
    hideElement(tooltipCustomer);
    hideElement(tooltipIntro); 
    showElement(btnOpen);
    hideElement(btnClose);
  };

  // --- Intro tooltip al load se non già visto ---
  if (!sessionStorage.getItem(SESSION_KEY)) {
    showElement(tooltipIntro);

    setTimeout(() => {
      hideElement(tooltipIntro);
      introHidden = true;
      sessionStorage.setItem(SESSION_KEY, '1');
    }, 30000);
  } else {
    introHidden = true;
  }

  // --- Eventi click ---
  btnOpen.addEventListener('click', showTooltipCustomer);
  btnClose.addEventListener('click', hideTooltipCustomer);

  tooltipIntroLink.addEventListener('click', (e) => {
    e.preventDefault();
    showTooltipCustomer();
    introHidden = true;
    sessionStorage.setItem(SESSION_KEY, '1');
  });

  // Click fuori tooltip chiude customer
  document.addEventListener('click', (e) => {
    if (!introHidden) return;
    if (!whatsapp.contains(e.target)) {
      hideTooltipCustomer();
    }
  });
});
